import { useCallback, useEffect } from 'react';
import { unit, pxToRem } from '../../../foundation/spacing/utils.js';

function useAutoHeight(options) {
  var textAreaRef = options.textAreaRef,
    minHeight = options.minHeight,
    _options$enabled = options.enabled,
    enabled = _options$enabled === void 0 ? false : _options$enabled;
  var setAutoHeight = useCallback(function () {
    if (textAreaRef.current) {
      textAreaRef.current.style.minHeight = unit(minHeight); // reset height, otherwise it wont shrink when deleting content
      textAreaRef.current.style.minHeight = pxToRem(textAreaRef.current.scrollHeight + 2); // add a little extra to avoid scrollbar
    }
  }, [minHeight, textAreaRef]);
  useEffect(function () {
    if (enabled) {
      setAutoHeight();
    }
  }, [enabled, setAutoHeight]);
  return {
    setAutoHeight: setAutoHeight
  };
}

export { useAutoHeight };
